/**
 * กติกาว่าตอนไหนตัวละครควรถืออาวุธ
 *
 * แยกออกมาเป็น pure function เพราะเป็นกฎของเกม ไม่ใช่เรื่องการวาด
 * จึงเทสต์ได้โดยไม่ต้องมีฉาก Babylon หรือต่อ server
 */

/**
 * ถืออาวุธต่ออีกกี่มิลลิวินาทีหลังจังหวะต่อสู้ครั้งล่าสุด
 *
 * **ตรงกับ `REGEN_DELAY_SEC` ฝั่ง server โดยตั้งใจ** (ไม่โดนตีครบ 4 วิ แล้วเลือดเริ่มฟื้น)
 * การเก็บอาวุธจึงไม่ใช่แค่ความสวยงาม แต่เป็นสัญญาณว่า "ออกจากการต่อสู้แล้ว"
 * ซึ่งเป็นข้อมูลที่ผู้เล่นใช้ตัดสินใจได้จริง แก้ค่าหนึ่งแล้วควรแก้อีกค่าให้ตรงกัน
 *
 * ไม่ต้องยาวเผื่อช่วงรอคูลดาวน์ เพราะการ "สั่งตีค้างไว้" ถูกคุมด้วย `fighting` แยกต่างหาก
 */
export const COMBAT_HOLD_MS = 4000;

/** สถานะเท่าที่กติกานี้ต้องใช้ */
export interface CombatHoldState {
  /** performance.now ที่จะเก็บอาวุธ */
  combatUntil?: number;
  /** กำลังล็อกเป้าสั่งตีอยู่ */
  fighting?: boolean;
}

/** บันทึกว่าเพิ่งมีเหตุการณ์ต่อสู้ ต่ออายุการถืออาวุธออกไป */
export function markCombat(state: CombatHoldState, now: number): void {
  state.combatUntil = now + COMBAT_HOLD_MS;
}

/**
 * ตอนนี้ควรถืออาวุธอยู่ไหม
 *
 * สองเงื่อนไข แยกกันคนละหน้าที่
 *   1. `fighting` — **ยังสั่งตีอยู่** (มีเป้าที่ล็อกไว้) เป็นสถานะ ไม่ใช่เวลา
 *      จึงไม่กะพริบระหว่างรอคูลดาวน์ ต่อให้สกิลคูลดาวน์ยาว 24 วินาที
 *   2. `combatUntil` — เพิ่งมีเหตุการณ์ต่อสู้ (ตี โดนตี ร่ายสกิลเอง)
 *      **การได้รับบัฟจากเพื่อนไม่นับ** คนที่ยืนรอบัฟไม่ได้เริ่มสู้กับใคร
 *      คุมหางของการต่อสู้ รวมถึงคนที่โดนรุมโดยไม่ได้สั่งตีใคร
 */
export function heldOn(state: CombatHoldState, now: number): boolean {
  return state.fighting === true || (state.combatUntil ?? 0) > now;
}
